




































import { Component, Vue } from 'vue-property-decorator';

import { INotification } from '@/components/Global/Notification.vue';

import { getSettings, updateSettings } from '@/services/Settings';

import { captureException as sentryCaptureException } from '@sentry/browser';

import Welcome from '@/components/Global/Welcome.vue';
import Alert from '@/components/Global/Alert.vue';
import Loading from '@/components/Global/Loading.vue';
import TextArea from '@/components/Form/TextArea.vue';
import SwitchField from '@/components/Form/SwitchField.vue';

@Component({
	name: 'RiskResources',
	components: {
		Alert,
		Loading,
		Welcome,
		TextArea,
		SwitchField,
	},
})
export default class RiskResources extends Vue {
	private loading: boolean = true;
	private error: boolean = false;
	private updateError: boolean = false;
	private success: boolean = false;
	private agentResourcesStatus: { setting_key: string; active: boolean; public: boolean } = {
		setting_key: 'agentResourcesStatus',
		active: false,
		public: false,
	};

	private async saveSettings() {
		this.success = false;
		this.updateError = false;

		try {
			const setting = [this.agentResourcesStatus];

			await updateSettings(setting);

			this.success = true;
		} catch (e) {
			this.updateError = true;
			sentryCaptureException(e);
		}
	}

	private async created() {
		try {
			const { data } = await getSettings(['agentResourcesStatus']);

			if (data.find(s => s.setting_key === 'agentResourcesStatus') !== undefined) {
				this.agentResourcesStatus = data.find(
					s => s.setting_key === 'agentResourcesStatus',
				);
				this.agentResourcesStatus.public = true;
			}
		} catch (e) {
			this.error = true;
			sentryCaptureException(e);
		} finally {
			this.loading = false;
		}
	}
}
